const Hero = () => {
    return(
        <section className="mt-8 mobile:mt-1">
            <h1 className="flex flex-col text-5xl font-bold text-primary-200 md:text-center md:gap-5 mobile:text-3xl mobile:gap-1">
                <span>CGPA Simulator</span>
            </h1>
        </section>
    )
}

export default Hero